import React from "react";
import { InputSwitch } from "primereact/inputswitch";
import { confirmDialog } from "primereact/confirmdialog";

interface StatusEmployeeSwitchProps {
  rowData: any;
}

const StatusEmployeeSwitch: React.FC<StatusEmployeeSwitchProps> = ({
  rowData,
}) => {
  const removeEmployee = (id: string) => {
    confirmDialog({
      message: "Confirma a inativação do empregado?",
      header: "Inativar Empregado",
      accept: () => console.log("Employee removed", id),
      reject: () => console.log("Operation canceled"),
    });
  };

  return (
    <div>
      <InputSwitch
        checked={rowData.isActive}
        disabled
        onChange={() => removeEmployee(rowData.id)}
      />
    </div>
  );
};

export default StatusEmployeeSwitch;
